export enum ClientWhitelistDataTypeENUM {
    EMAIL = 1,
    DOMAIN = 2,
    IP = 3,
    OTHER = 4
}